import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TableDataSouce, YshTableSetComponent } from '../../components/ysh-table-set/ysh-table-set.component';
import { ReportService } from '../../services/report.service';
import { Report } from '../../models/report';
import { FileFormat } from '../../services/api.service';
import { CompanyService } from '../../services/api/company/company.service';
import { first, mergeMap } from 'rxjs';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrl: './reports.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        YshTableSetComponent,
    ]
})
export class ReportComponent implements OnInit {

  @Input() name: string;

  dataSource: TableDataSouce<any>;
  report?: Report;
  private accountUid?: string;

  constructor(
    private companyService: CompanyService,
    private reportService: ReportService,
  ) {}

  ngOnInit(): void {
    this.getReport();
  }

  getReport(): void {
    this.companyService.currentCompany$.pipe(
      first(),
      mergeMap(company => {
        this.accountUid = company?.accountUid;
        return this.reportService.get(this.name, undefined, this.accountUid);
      })
    ).subscribe(report => {
      this.report = report;
      this.dataSource = {
        title: this.report.title,
        load: (state) => this.reportService.getData(this.name, state, this.accountUid),
        filters: [],
        actions: [
          {
            buttonLabel: 'Download CSV',
            buttonIcon: 'file_download',
            onTap: () => this.didTapDownloadCSV(),
          },
        ],
        columns: this.report.columns
      };
    });
  }

  didTapDownloadCSV(): void {
    this.reportService.download(this.name, FileFormat.CSV, {}, this.accountUid);
  }
}
